import React, { FC, ReactNode } from 'react';

/**
 * Wraps and centers an error page from sl-component-error-pages into the app view.
 *
 * @param children
 */
export const ErrorPageWrapper: FC<ErrorPageWrapperProps> = ({ children }) => (
  <div className="flex items-center h-full">
    {children}
  </div>
);

export interface ErrorPageWrapperProps {
  children: ReactNode
}
